import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';

import { ApplicationSettingsApi } from '../api/application-settings.api';
import { ApplicationSettings } from '../api/model/application-settings';

@Injectable()
export class ApplicationSettingsService {
  private _settings!: ApplicationSettings;
  applicationSettings$ = new BehaviorSubject<ApplicationSettings>(
    {} as ApplicationSettings,
  );
  private _loadFailed = false;

  setLoadFailed(failed: boolean) {
    this._loadFailed = failed;
  }

  get loadFailed() {
    return this._loadFailed;
  }

  get settings(): ApplicationSettings {
    return this._settings;
  }

  loadInitialSettings() {
    return firstValueFrom(
      this.applicationSettingsApi.getApplicationSettings(),
    ).then((s) => {
      this._settings = s;
      this.applicationSettings$.next(s);
    });
  }

  constructor(
    private readonly applicationSettingsApi: ApplicationSettingsApi,
  ) {}
}
